<template>
  <div :id="id" @contextmenu.prevent="handler($event)"
       class="sitebuilder-element-container"
       element="LaunchAppComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :config-properties="JSON.stringify(internal_config)" :style="style()" v-on:click="focusElement($event)">


    <vue-draggable-resizable v-bind:w="parseInt(internal_config.width)" v-bind:h="parseInt(internal_config.height)"
                             @resizing="onResize" :draggable="false" ref="draggableResizable">

      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-LaunchAppComponent'></options-element-bar>



      <div class="launch-app-container" style="padding-top: 30px">
        <div class="desktop-element">
          <div class="form-row align-items-center">

            <div class="form-group col-9">
              <input :style="styleInput()" type="text" class="form-control" readonly :value="`https://${$t('ct-mysite')}.com/page?ORIGIN_UID=xxxx`">
            </div>

            <div class="form-group col-3">
              <button class="btn"
                      :style="buttonTextStyle()"> {{ $t('ct-launch-copy') }} </button>
            </div>

          </div>
        </div>


        <div class="form-row align-items-center mobile-element">

          <div class="input-group mb-3">
            <input  :style="styleInput(true)" type="text" class="form-control" readonly :value="`https://${$t('ct-mysite')}.com/page?ORIGIN_UID=xxxx`">
            <div class="input-group-append">
              <span :style="buttonTextStyle(true)" style="cursor: pointer" class="input-group-text"> <i class="fa fa-copy"></i> </span>
            </div>
          </div>

        </div>

        <div :style="shareBarDivStyle()" class="share-bar">
          <a v-show="internal_config.show.share_email" href="#" target="_blank"  :style="shareButtonStyle()" class="post-share-icon far fa-envelope"></a>
          <a v-show="internal_config.show.share_facebook" href="#" target="_blank"  :style="shareButtonStyle()" class="post-share-icon fab fa-facebook-f"></a>
          <a v-show="internal_config.show.share_twitter" href="#" target="_blank"  :style="shareButtonStyle()" class="post-share-icon icon-x"><builderall-icon code='new-twitter'></builderall-icon></a>
          <a v-show="internal_config.show.share_linkedin" href="#" target="_blank"  :style="shareButtonStyle()" class="post-share-icon fab fa-linkedin-in"></a>
          <a v-show="internal_config.show.share_whatsapp" href="#" target="_blank" :style="shareButtonStyle()" class="post-share-icon fab fa-whatsapp"></a>
          <a v-show="internal_config.show.share_telegram" href="#" :style="shareButtonStyle()" class="post-share-icon fab fa-telegram"></a>
        </div>

        <div  :style="{ 'padding-left': internal_config.texts.padding.left, 'padding-top': internal_config.texts.padding.top }" style=" padding-top: 55px">

          <div v-show="internal_config.show.ranking" >
            <p :style="titlePositionStyle()" class="clean-text-css">{{ $t('ct-launch-position') }}</p>
            <p :style="resultPositionStyle()" class="clean-text-css">1</p>
          </div>

          <div v-show="internal_config.show.count" :style="{'margin-top': internal_config.texts.padding.between }" class="form-group">
            <p :style="titlePositionStyle()" class="clean-text-css">{{ $t('ct-launch-count') }}</p>
            <p :style="resultPositionStyle()" class="clean-text-css">13.465</p>
          </div>

        </div>



      </div>



    </vue-draggable-resizable>
  </div>

</template>

<script>

import elementData from './Model';
import OptionsElementBar from '../../OptionsElementBar';
import _ from 'lodash'
import { SweetModal } from 'sweet-modal-vue'



export default {
  name: 'LaunchAppComponent',
  props: ['config', 'id'],
  components: { OptionsElementBar, SweetModal },
  data() {
    return elementData.data();
  },
  methods: {
    shareControl(key) {

    },
    build (config) {
      this.internal_config = _.merge(this.internal_config, config);
    },
    handler: function(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this, true);
      e.stopPropagation();
      e.preventDefault();
    },
    focusElement(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this);

      e.stopPropagation();
      e.preventDefault();
    },
    onResize: function(x, y, width, height) {
      this.internal_config.width = width + 'px';
      this.internal_config.height = height + 'px';
    },
    shareBarDivStyle() {
      return `display: flex; justify-content: ${this.internal_config.show.share_align}; flex-wrap: wrap;`;
    },
    shareButtonStyle() {
      let prop = (this.internal_config.show.share_theme === 'circle') ? 'border-radius: 50%;' : '';
      return prop;
    },
    style() {
      return  `width: ${this.internal_config.width};
               height:  ${this.internal_config.height};
               z-index: ${this.internal_config.zIndex};
               margin: 0 auto;
               padding-top: ${this.internal_config.paddingTop};
               padding-left: ${this.internal_config.paddingLeft};
               padding-right: ${this.internal_config.paddingRight};
               padding-bottom: ${this.internal_config.paddingBottom};
               left:  ${this.internal_config.left};
               top: ${this.internal_config.top}`;
    },
    buttonTextStyle(mobile = false) {
      return    `font-family:  ${this.internal_config.button.family};
                  font-size: ${this.internal_config.button.size}px;
                  text-align: ${this.internal_config.button.align};
                  font-weight: ${this.internal_config.button.weight};
                  font-style: ${this.internal_config.button.style};
                  text-decoration: ${this.internal_config.button.stroke};
                  color: ${this.internal_config.button.color};
                  background: ${this.internal_config.button.background};
                  border-radius : ${this.internal_config.button.radius};

                  padding-left: ${!mobile ? this.internal_config.button.horizontalPadding : 'auto'};
                  padding-right: ${!mobile ? this.internal_config.button.horizontalPadding : 'auto'};
                  padding-top: ${!mobile ? this.internal_config.button.verticalPadding : 'auto'};
                  padding-bottom: ${!mobile ? this.internal_config.button.verticalPadding : 'auto'};
                  margin-left: ${!mobile ? this.internal_config.button.paddingLeft : 'auto'};`;
    },
    titlePositionStyle() {
      return    `font-family:  ${this.internal_config.texts.position_title.family};
                  font-size: ${this.internal_config.texts.position_title.size}px;
                  text-align: ${this.internal_config.texts.position_title.align};
                  font-weight: ${this.internal_config.texts.position_title.weight};
                  font-style: ${this.internal_config.texts.position_title.style};
                  text-decoration: ${this.internal_config.texts.position_title.stroke};
                  color: ${this.internal_config.texts.position_title.color}`;
    },
    resultPositionStyle() {
      return    `font-family:  ${this.internal_config.texts.position_result.family};
                  font-size: ${this.internal_config.texts.position_result.size}px;
                  text-align: ${this.internal_config.texts.position_result.align};
                  font-weight: ${this.internal_config.texts.position_result.weight};
                  font-style: ${this.internal_config.texts.position_result.style};
                  text-decoration: ${this.internal_config.texts.position_result.stroke};
                  color: ${this.internal_config.texts.position_result.color}`;
    },
    styleInput(mobile = false) {
      return     `font-family:  ${this.internal_config.input.family};
                  font-size: ${mobile ? this.internal_config.input.sizeMobile : this.internal_config.input.size}px;
                  text-align: ${this.internal_config.input.align};
                  font-weight: ${this.internal_config.input.weight};
                  font-style: ${this.internal_config.input.style};
                  text-decoration: ${this.internal_config.input.stroke};
                  color: ${this.internal_config.input.color};
                  height:  ${this.internal_config.input.height}`;
    }
  },
  mounted() {
    this.build(this.$props.config);
  },
  watch: {
    'internal_config': {
      deep: true,
      handler(value) {
        this.$eventHub.setValueElementConfig(this.id, value);
        this.$eventPointer.log(this.id, value);
      }
    }
  }
}
</script>

<style scoped>

.launch-app-container{
  padding-left: 5px;
  padding-right: 5px;
}

.post-share-icon {
  margin-top: 5px;
  margin-left: 2px;
  padding: 15px;
  font-size: 20px;
  width: 50px;
  height: 50px;
  text-align: center;
  text-decoration: none;
}

/* Add a hover effect if you want */
.post-share-icon:hover {
  opacity: 0.7;
}

/* Set a specific color for each brand */

/* Facebook */
.fa-facebook-f {
  background: #3B5998;
  color: white;
}

/* Twitter */
.icon-x {
  background: #12100e;
  color: white;
  display: flex;
  justify-content: center;

  builderall-icon {
    --builderall-icon-size: 22px;
  }
}

/* Instagram */
.fa-instagram {
  background: #d00174;
  color: white;
}

/* Linkedin */
.fa-linkedin-in {
  background: #2867b2;
  color: white;
}

/* Youtube */
.fa-pinterest {
  background: #ff0000;
  color: white;
}

/* Medium */
.fa-medium-m {
  background: #12100e;
  color: white;
}

/* Email */
.fa-envelope {
  background: #363636;
  color: white;
}

/* Copy */
.fa-link {
  background: #363636;
  color: white;
}

/* whatsapp */
.fa-whatsapp {
  background: #25D366;
  color: white;
}

/* telegram */
.fa-telegram {
  background: #0088cc;
  color: white;
}

</style>




// WEBPACK FOOTER //
// src/components/editor/apps/Forms/Launch/LaunchApp.vue